/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable react/jsx-key */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Stack,
  Radio,
  Dialog,
  TextField,
  Typography,
  DialogActions,
  DialogContent,
  LinearProgress
} from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import MyChip from '../../../components/MyChip';
import SearchIcon from '@mui/icons-material/Search';
import { appColors } from '../../../../../utils/theme';
import RoleTypeTag from '../../../components/RoleTypeTag';
import ChatAvatarComponent from '../../chat/ChatAvatarComponent';
import { camelCaseToCapital } from '../../../../../utils/topicsMapping';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import DosenButton from '../../../../../components/ui/Buttons/DosenButton';
import { camelCaseToCapitalIndustries } from '../../../../../utils/industriesMapping';
import { GroupBasedRoleFormatter, roleNameFormatter } from '../../../components/common';

interface AssignMatchPopup2Props {
  openAssignMentorSecond: any;
  handelCloseAssineMatch: any;
  action: any;
  recommendations: any;
  setSelectedRecommendation: (rec: any) => void;
  suggestions: any;
  handleSubmitAssignMatch: any;
  loaderFirstPopup: any;
}

const AIScoreBadge = ({ score }: { score: number }) => {
  const getColor = () => {
    if (score >= 85) return '#4CAF50';
    if (score >= 70) return '#F79420';
    return '#B6B6B6';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: 1,
        border: `1px solid ${getColor()}`,
        backgroundColor: `${getColor()}14`
      }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: getColor() }}>
        {score}%
      </Typography>
    </Box>
  );
};

function AssignMatchPopup2({
  openAssignMentorSecond,
  handelCloseAssineMatch,
  action,
  recommendations,
  suggestions,
  setSelectedRecommendation,
  handleSubmitAssignMatch,
  loaderFirstPopup
}: AssignMatchPopup2Props) {
  const [selectedRadioValue, setSelectedRadioValue] = useState<string | null>(null);
  const [searchText, setSearchText] = useState('');
  const useStyles = makeStyles({
    memberCircleImage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '50px',
      height: '50px',
      position: 'relative'
    },
    memberCircleInner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '50px',
      height: '50px',
      background: '#fff',
      borderRadius: '50%'
    }
  });

  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor');
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee');
  const mentorRoleTextLowerCase = mentorRoleText.toLowerCase();
  const menteeRoleTextLowerCase = menteeRoleText.toLowerCase();
  const classes = useStyles();

  const isAIMode = recommendations?.some((rec: any) => rec.aiReasoning);

  const filteredRecommendations = recommendations?.filter((rec: any) =>
    (rec.name || rec.displayName)?.toLowerCase().includes(searchText.toLowerCase())
  );

  const filteredSuggestions = suggestions?.filter((sug: any) =>
    (sug.name || sug.displayName)?.toLowerCase().trim().includes(searchText.toLowerCase().trim())
  );

  const formatBio = (name1: string, name2: string) => {
    if (!name1 || !name2) return '';
    return (
      <>
        {name1
          ?.split(' ')
          ?.map((each: any) => each.charAt(0).toUpperCase().concat(each?.slice(1)))
          .join(' ')
          .concat(', ')}
        {name2
          ?.split(' ')
          ?.map((each: any) => each.charAt(0).toUpperCase().concat(each?.slice(1)))
          ?.join(' ')}
      </>
    );
  };

  const getBio = (mem: any) => {
    const major: string = mem?.bio?.education?.major;
    const university: string = mem?.bio?.education?.university;
    const role: any = mem?.bio?.workHistory?.role;
    const company: any = mem?.bio?.workHistory?.companyName;
    return formatBio(major, university) || formatBio(role, company);
  };

  const renderTopics = (topics: string[]) => (
    <Stack direction="row" useFlexGap flexWrap="wrap" spacing={0.5} alignItems="center">
      {topics.map((ele, index) => (
        <React.Fragment key={index}>
          <MyChip label={ele} backgroundColor="#FFFFFF" color="#68717A" border="1px Solid #CED4DA" />
        </React.Fragment>
      ))}
    </Stack>
  );

  const renderRecommendationCard = (ele: any, index: number) => {
    const allTopics = [
      ...camelCaseToCapital(ele.topics || []),
      ...camelCaseToCapitalIndustries(ele.industries || [])
    ];

    const idValue = action === 'Assign Mentor' ? ele.mentorId : ele.menteeId;

    return (
      <Box
        key={idValue || index}
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        gap="8px"
        py={2}
        borderBottom="1px solid #EFF0F4"
      >
        <Box flex={1}>
          <Box display="flex" gap="8px" alignItems="center">
            <ChatAvatarComponent
              height="48px"
              width="48px"
              image={ele?.image || ele?.headshot}
              firstLetter={(ele?.name || ele?.displayName)?.slice(0, 1)}
            />
            <Box flex={1}>
              <Box display="flex" alignItems="center" gap="8px">
                <Typography variant="h5">{ele?.name || ele?.displayName}</Typography>
                <RoleTypeTag category={roleNameFormatter(ele?.role, mentorRoleText, menteeRoleText)} />
                {ele.aiScore != null && <AIScoreBadge score={ele.aiScore} />}
              </Box>
              <Box>
                <Typography>{getBio(ele)}</Typography>
              </Box>
            </Box>
          </Box>

          {ele.aiReasoning && (
            <Box
              sx={{
                mt: 1,
                ml: 7,
                p: 1.5,
                borderRadius: 1.5,
                backgroundColor: '#1A1A1A',
                border: '1px solid #2A2A2A'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#F79420' }}>
                  Elliott&apos;s reasoning
                </Typography>
              </Box>
              <Typography sx={{ fontSize: 13, color: '#B6B6B6', lineHeight: 1.5 }}>
                {ele.aiReasoning}
              </Typography>
            </Box>
          )}

          {allTopics.length > 0 && (
            <Box mt={1} ml={5.6}>
              {renderTopics(allTopics)}
            </Box>
          )}
        </Box>

        <Box>
          <Radio
            id={`radio-rec-${index}`}
            name="selectedRecommendation"
            value={idValue}
            checked={selectedRadioValue === idValue}
            onChange={() => {
              setSelectedRadioValue(idValue);
              setSelectedRecommendation(ele);
            }}
          />
        </Box>
      </Box>
    );
  };

  return (
    <Dialog open={openAssignMentorSecond} onClose={handelCloseAssineMatch} fullWidth>
      <CommonModalHeader
        title={
          isAIMode
            ? "Elliott's matches"
            : action === 'Assign Mentor'
            ? 'Assign a ' + mentorRoleTextLowerCase
            : 'Assign a ' + menteeRoleTextLowerCase
        }
        handleCloseModal={handelCloseAssineMatch}
      />
      <DialogContent>
        {isAIMode && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 2,
              p: 1.5,
              borderRadius: 1.5,
              background: 'linear-gradient(135deg, #F7942014 0%, #F7A94D08 100%)',
              border: '1px solid #F7942033'
            }}
          >
            <Typography sx={{ fontSize: 13, color: '#B6B6B6' }}>
              Elliott analyzed profiles to find the best matches based on goals, background, and compatibility.
            </Typography>
          </Box>
        )}

        <Box mb={2}>
          <Box
            border={`1px solid ${appColors.gray1}`}
            borderRadius={2}
            display="flex"
            alignItems="center"
            width="100%"
            height="40px"
            padding={1.2}
          >
            <SearchIcon
              sx={{
                color: appColors.gray4,
                marginRight: '7px',
                width: '16.6px',
                height: '16.6px'
              }}
            />
            <TextField
              variant="standard"
              placeholder={`Search ${mentorRoleTextLowerCase}`}
              style={{
                borderColor: 'transparent',
                padding: '0px !important',
                margin: 0,
                paddingBottom: 0,
                color: '#68717A'
              }}
              size="small"
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              InputProps={{
                disableUnderline: true
              }}
            />
          </Box>
        </Box>

        <Typography variant="h5" mb={1}>
          {isAIMode ? "Elliott's recommendations" : 'Recommended'}
        </Typography>

        {filteredRecommendations?.map((ele: any, index: number) =>
          renderRecommendationCard(ele, index)
        )}

        {filteredRecommendations?.length === 0 && filteredSuggestions?.length === 0 && (
          <Typography>No matches found</Typography>
        )}

        {!isAIMode &&
          filteredSuggestions?.map((ele: any, index: number) => {
            const allTopics = [
              ...camelCaseToCapital(ele.topics || []),
              ...camelCaseToCapitalIndustries(ele.industries || [])
            ];

            return (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap="8px"
                py={2}
                borderBottom={index < filteredSuggestions.length - 1 ? '1px solid #EFF0F4' : 'none'}
              >
                <Box>
                  <Box display="flex" gap="8px" alignItems="center">
                    <ChatAvatarComponent
                      height="48px"
                      width="48px"
                      image={ele?.headshot || ele?.image}
                      firstLetter={ele?.displayName?.slice(0, 1) || ele?.name?.slice(0, 1)}
                    />
                    <Box>
                      <Box display="flex" alignItems="center" gap="8px">
                        <Typography variant="h5">{ele?.displayName || ele?.name}</Typography>
                        <RoleTypeTag
                          category={roleNameFormatter(ele?.role, mentorRoleText, menteeRoleText)}
                        />
                      </Box>
                      <Box>
                        <Typography>{getBio(ele)}</Typography>
                      </Box>
                    </Box>
                  </Box>
                  {filteredSuggestions.length > 0 && (
                    <Box mt={1} ml={5.6}>
                      {renderTopics(allTopics)}
                    </Box>
                  )}
                </Box>
                <Box>
                  <Radio
                    id={`radio-sug-${index}`}
                    name="selectedRecommendation"
                    value={action === 'Assign Mentor' ? ele.mentorId : ele.menteeId}
                    checked={
                      selectedRadioValue === (action === 'Assign Mentor' ? ele.mentorId : ele.menteeId)
                    }
                    onChange={() => {
                      setSelectedRadioValue(
                        action === 'Assign Mentor' ? ele.mentorId : ele.menteeId
                      );
                      setSelectedRecommendation(ele);
                    }}
                  />
                </Box>
              </Box>
            );
          })}
      </DialogContent>

      <DialogActions>
        <DosenButton fullWidth loading={loaderFirstPopup} loadingText="Assigning..." onClick={handleSubmitAssignMatch}>
          Select
        </DosenButton>
      </DialogActions>
    </Dialog>
  );
}

export default AssignMatchPopup2;
